




















































import Component, {mixins} from "vue-class-component";
import AuthMixin from "../mixins/auth.mixin";
import {Emit, Prop, Ref} from "vue-property-decorator";
import {IUser, UserLevel, UserLevels} from "shared/entities/user";
import {CreateUserRequest} from "shared/api/routes/user";
import {BModal} from "bootstrap-vue";
import {apiHandler} from "@/services/api-handler";
import {Api} from "shared/api";

@Component({})
export default class AddUser extends mixins(AuthMixin) {
    private addUserProps: CreateUserRequest = {firstName: "", lastName: "", email: "", level: UserLevel.Employee};

    @Prop({required: true})
    owners!: IUser[];

    @Ref()
    private readonly addUserModel!: BModal;

    UserLevel = UserLevel

    get levels() {
        if (this.user?.level !== UserLevel.Admin)
            return UserLevels.filter(level => level < (this.user?.level ?? 0)).map(level => ({level, title: UserLevel[level]}));
        else
            return UserLevels.map(level => ({level, title: UserLevel[level]}));
    }

    @Emit("finished")
    private finished(user: IUser): IUser {
        this.addUserModel.hide();
        return user;
    }

    private async addUser() {
        const user = await apiHandler(() => Api.user.Post(this.addUserProps));
        if (user.valid) this.finished(user.user);
        else alert(user.error);
    }

    public show() {
        this.addUserProps = {firstName: "", lastName: "", email: "", level: UserLevel.Employee};
        this.addUserModel.show();
    }
}
